import { CA_AUTOSHIP_MAX_SAVINGS, US_AUTOSHIP_MAX_SAVINGS } from '@libs/core';

import { getENV } from './env';

export const getAutoshipMaxSavings = (): string => {
    return getENV('NEXT_PUBLIC_LOCALE') === 'en-CA' ? CA_AUTOSHIP_MAX_SAVINGS : US_AUTOSHIP_MAX_SAVINGS;
};
